"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetTaxes = exports.SiteTaxes = exports.TaxRule = exports.DemandEstimate = exports.SiteHardwareTelemetry = exports.PowernodeTelemetry = exports.ChargerTelemetry = exports.PortTelemetry = exports.SiteDetails = exports.SiteList = exports.OrganizationStats = exports.SiteRevenueStats = exports.SiteTransactionStats = exports.RevenueStats = exports.FreeSessionLimitType = exports.FeeBreakdown = exports.TransactionStats = exports.SiteResourceStats = exports.ResourceStats = exports.SiteSettings = void 0;
const ee_proto_interfaces_1 = require("ee-proto-interfaces");
const ee_proto_interfaces_2 = require("ee-proto-interfaces");
const ee_proto_interfaces_3 = require("ee-proto-interfaces");
const swagger_proxy_1 = require("./swagger-proxy");
const class_validator_proxy_1 = require("./class-validator-proxy");
const class_transformer_proxy_1 = require("./class-transformer-proxy");
class SiteSettings {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Whether remote payment authorization is enabled for this site",
        example: true,
        type: Boolean,
    }),
    (0, class_validator_proxy_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], SiteSettings.prototype, "enableRemotePaymentAuthorization", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "When true, this site's chargers must only accept OCPP/OCPI-based authorization; payment-provider-based flows (e.g. card payments) are disabled",
        example: false,
        type: Boolean,
    }),
    (0, class_validator_proxy_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], SiteSettings.prototype, "restrictToOcppOcpiAuth", void 0);
exports.SiteSettings = SiteSettings;
/**
 * The stats for a given resource (site, organization, etc.).
 */
class ResourceStats {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Uptime percentage (0-1)",
        example: 0.95,
        type: Number,
        minimum: 0,
        maximum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], ResourceStats.prototype, "uptime", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Usage percentage (0-1)",
        example: 0.75,
        type: Number,
        minimum: 0,
        maximum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], ResourceStats.prototype, "usage", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Idle time percentage (0-1)",
        example: 0.2,
        type: Number,
        minimum: 0,
        maximum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], ResourceStats.prototype, "idle", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Unavailable time percentage (0-1)",
        example: 0.05,
        type: Number,
        minimum: 0,
        maximum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], ResourceStats.prototype, "unavailable", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total energy dispensed in kWh over the queried window",
        example: 1234.5,
        type: Number,
        minimum: 0,
        required: false,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    (0, class_validator_proxy_1.IsOptional)(),
    __metadata("design:type", Number)
], ResourceStats.prototype, "energyDispensedKwh", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Number of charging sessions that dispensed meaningful (> 0.01 kWh) energy over the queried window",
        example: 42,
        type: Number,
        minimum: 0,
        required: false,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    (0, class_validator_proxy_1.IsOptional)(),
    __metadata("design:type", Number)
], ResourceStats.prototype, "successfulSessionCount", void 0);
exports.ResourceStats = ResourceStats;
/**
 * The resource stats for a given site.
 */
class SiteResourceStats extends ResourceStats {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Id of the Site",
        example: 47,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], SiteResourceStats.prototype, "id", void 0);
exports.SiteResourceStats = SiteResourceStats;
class TransactionStats {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total number of transactions",
        example: 47,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionStats.prototype, "numberOfTransactions", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total energy dispensed in kWh",
        example: 1234.56,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionStats.prototype, "energyDispensed", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Average energy per transaction in kWh",
        example: 26.27,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionStats.prototype, "averageEnergyPerTransaction", void 0);
exports.TransactionStats = TransactionStats;
class FeeBreakdown {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Number of payment authorizations processed",
        example: 150,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], FeeBreakdown.prototype, "authorizationCount", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total cost of authorizations multiplied by precision factor",
        example: 7500,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], FeeBreakdown.prototype, "authorizationCost", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Decimal precision factor for authorization cost",
        example: 100,
        type: Number,
        minimum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], FeeBreakdown.prototype, "authorizationCostPrecision", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Estimated interchange percentage rate",
        example: 1.75,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], FeeBreakdown.prototype, "interchangePercentEstimate", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Interchange cost multiplied by precision factor",
        example: 2500,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], FeeBreakdown.prototype, "interchangeCost", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Decimal precision factor for interchange cost",
        example: 100,
        type: Number,
        minimum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], FeeBreakdown.prototype, "interchangeCostPrecision", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Number of completed transactions",
        example: 125,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], FeeBreakdown.prototype, "completions", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total revenue amount multiplied by precision factor",
        example: 125000,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], FeeBreakdown.prototype, "revenueAmount", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Decimal precision factor for revenue amount",
        example: 100,
        type: Number,
        minimum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], FeeBreakdown.prototype, "revenueAmountPrecision", void 0);
exports.FeeBreakdown = FeeBreakdown;
var FreeSessionLimitType;
(function (FreeSessionLimitType) {
    FreeSessionLimitType["COST"] = "COST";
    FreeSessionLimitType["COUNT"] = "COUNT";
})(FreeSessionLimitType = exports.FreeSessionLimitType || (exports.FreeSessionLimitType = {}));
/**
 * Revenue Statistics Summary
 *
 * Financial summary data including total revenue, transaction counts, and monetary precision details.
 * Used for site and organization-level revenue reporting and analytics.
 */
class RevenueStats {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total revenue amount in the specified currency, multiplied by precision factor",
        example: 125430,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], RevenueStats.prototype, "revenueAmount", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Decimal precision factor for monetary amounts (e.g., 100 for cents, 1000 for thousandths)",
        example: 100,
        type: Number,
        minimum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], RevenueStats.prototype, "precision", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "ISO currency code for the revenue amount",
        example: "USD",
        type: String,
        minLength: 3,
        maxLength: 3,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], RevenueStats.prototype, "currency", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total number of transactions included in this revenue calculation",
        example: 47,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], RevenueStats.prototype, "transactionCount", void 0);
exports.RevenueStats = RevenueStats;
class SiteTransactionStats extends TransactionStats {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Id of the Site",
        example: 47,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], SiteTransactionStats.prototype, "id", void 0);
exports.SiteTransactionStats = SiteTransactionStats;
class SiteRevenueStats extends RevenueStats {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Id of the Site",
        example: 47,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], SiteRevenueStats.prototype, "id", void 0);
exports.SiteRevenueStats = SiteRevenueStats;
/**
 * An organizations statistics, grouped by site and organization level.
 */
class OrganizationStats {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Overall organization statistics",
        type: ResourceStats,
    }),
    (0, class_validator_proxy_1.IsObject)(),
    (0, class_validator_proxy_1.ValidateNested)(),
    (0, class_transformer_proxy_1.Type)(() => ResourceStats),
    __metadata("design:type", ResourceStats)
], OrganizationStats.prototype, "orgStats", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Statistics for individual sites in the organization",
        type: SiteResourceStats,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => SiteResourceStats),
    __metadata("design:type", Array)
], OrganizationStats.prototype, "siteStats", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Transaction statistics for each site in the organization",
        type: SiteTransactionStats,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => SiteTransactionStats),
    __metadata("design:type", Array)
], OrganizationStats.prototype, "siteTransactionStats", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Revenue statistics for each site in the organization",
        type: SiteRevenueStats,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => SiteRevenueStats),
    __metadata("design:type", Array)
], OrganizationStats.prototype, "siteRevenueStats", void 0);
exports.OrganizationStats = OrganizationStats;
/**
 * A list of sites.
 */
class SiteList {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Array of site information",
        type: Object,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => Object),
    __metadata("design:type", Array)
], SiteList.prototype, "sites", void 0);
exports.SiteList = SiteList;
/**
 * Details for a site.
 */
class SiteDetails {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Site identifier",
        example: 42,
        type: Number,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], SiteDetails.prototype, "id", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Site name",
        example: "Downtown Charging Station",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], SiteDetails.prototype, "name", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Organization that owns this site",
        type: Object,
    }),
    (0, class_validator_proxy_1.IsObject)(),
    (0, class_validator_proxy_1.ValidateNested)(),
    (0, class_transformer_proxy_1.Type)(() => Object),
    __metadata("design:type", Object)
], SiteDetails.prototype, "ownerOrganization", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Power nodes at this site",
        type: Object,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => Object),
    __metadata("design:type", Array)
], SiteDetails.prototype, "powernodes", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Chargers at this site",
        type: Object,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => Object),
    __metadata("design:type", Array)
], SiteDetails.prototype, "chargers", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Expected date when site will come online",
        type: Date,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsDate)(),
    (0, class_transformer_proxy_1.Type)(() => Date),
    __metadata("design:type", Date)
], SiteDetails.prototype, "expectedDateOnline", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Date when site came online",
        type: Date,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsDate)(),
    (0, class_transformer_proxy_1.Type)(() => Date),
    __metadata("design:type", Date)
], SiteDetails.prototype, "onlineSince", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "First line of site address",
        example: "123 Main Street",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], SiteDetails.prototype, "addressLine1", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Second line of site address",
        example: "Suite 100",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], SiteDetails.prototype, "addressLine2", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Lockbox code for site access",
        example: 1234,
        type: Number,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Object)
], SiteDetails.prototype, "lockboxCode", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "State where site is located",
        example: "CA",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], SiteDetails.prototype, "state", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "IANA timezone for the site location",
        example: "America/Los_Angeles",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], SiteDetails.prototype, "timezone", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Number of active charging sessions",
        example: 3,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], SiteDetails.prototype, "activeSessions", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Grid power limit in kW",
        example: 150.0,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], SiteDetails.prototype, "gridLimit", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Site configuration settings",
        type: SiteSettings,
    }),
    (0, class_validator_proxy_1.IsObject)(),
    (0, class_validator_proxy_1.ValidateNested)(),
    (0, class_transformer_proxy_1.Type)(() => SiteSettings),
    __metadata("design:type", SiteSettings)
], SiteDetails.prototype, "settings", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Whether site access is restricted to members",
        example: false,
        type: Boolean,
    }),
    (0, class_validator_proxy_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], SiteDetails.prototype, "membershipRestricted", void 0);
exports.SiteDetails = SiteDetails;
/**
 * Latest telemetry for a given charger port.
 */
class PortTelemetry {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "OCPP status of the charging port",
        example: "Available",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], PortTelemetry.prototype, "ocppStatus", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "OCPP 2.0.1 charging_state (e.g. EV_CONNECTED, CHARGING, SUSPENDED_EV, SUSPENDED_EVSE, " +
            "IDLE), only populated for chargers that have moved off OCPP 1.6. Undefined for chargers " +
            "still on OCPP 1.6, which report granular state directly via ocppStatus instead.",
        example: "CHARGING",
        type: String,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], PortTelemetry.prototype, "chargingState", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Current connector/port state reported directly by charger firmware. Undefined for " +
            "firmware that doesn't report it yet.",
        enum: ee_proto_interfaces_3.charging_session_attempt.ChargerPortState,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], PortTelemetry.prototype, "connectorState", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "OCPI status (AVAILABLE/CHARGING/INOPERATIVE/etc.) computed server-side, preferring " +
            "connectorState when present and falling back to a derivation from ocppStatus otherwise.",
        example: "CHARGING",
        type: String,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], PortTelemetry.prototype, "ocpiStatus", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Current power output in kilowatts",
        example: 7.2,
        type: Number,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], PortTelemetry.prototype, "powerKw", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Maximum power limit in kilowatts",
        example: 11.0,
        type: Number,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], PortTelemetry.prototype, "powerLimitKw", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Whether power limits are applied per port",
        example: true,
        type: Boolean,
    }),
    (0, class_validator_proxy_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], PortTelemetry.prototype, "perPortPowerLimits", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Power requested by the vehicle in kilowatts",
        example: 7.2,
        type: Number,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], PortTelemetry.prototype, "powerRequestedKw", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Vehicle's state of charge percentage",
        example: 65.5,
        type: Number,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], PortTelemetry.prototype, "carSoC", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total energy delivered in this session (kWh)",
        example: 25.8,
        type: Number,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], PortTelemetry.prototype, "energyDelivered", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Type of charging port connector",
        enum: ee_proto_interfaces_2.charger.PortType,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], PortTelemetry.prototype, "portType", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total number of charging sessions on this port",
        example: 42,
        type: Number,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], PortTelemetry.prototype, "totalSessions", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Last time telemetry was updated",
        example: "2023-12-15T10:30:00.000Z",
        type: Date,
    }),
    (0, class_validator_proxy_1.IsDate)(),
    (0, class_transformer_proxy_1.Type)(() => Date),
    __metadata("design:type", Date)
], PortTelemetry.prototype, "updatedTime", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Whether a vehicle is physically connected",
        example: true,
        type: Boolean,
    }),
    (0, class_validator_proxy_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], PortTelemetry.prototype, "pluggedIn", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Whether payment authorization is ready",
        example: true,
        type: Boolean,
    }),
    (0, class_validator_proxy_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], PortTelemetry.prototype, "paymentReady", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Whether membership validation is ready",
        example: false,
        type: Boolean,
    }),
    (0, class_validator_proxy_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], PortTelemetry.prototype, "membershipReady", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Whether a charging transaction has started",
        example: true,
        type: Boolean,
    }),
    (0, class_validator_proxy_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], PortTelemetry.prototype, "transactionStarted", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Electric Vehicle Communication Controller ID",
        example: "EVCC123456789",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], PortTelemetry.prototype, "evccid", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Current fault code if any",
        example: "OVERVOLTAGE",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], PortTelemetry.prototype, "faultCode", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "When the current transaction started",
        example: "2023-12-15T09:15:00.000Z",
        type: Date,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsDate)(),
    (0, class_transformer_proxy_1.Type)(() => Date),
    __metadata("design:type", Date)
], PortTelemetry.prototype, "transactionStartTime", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Related transactions for this EVCCID",
        type: Object,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => Object),
    __metadata("design:type", Array)
], PortTelemetry.prototype, "evccidRelatedTransactions", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Current unavailable reasons for the port",
        enum: ee_proto_interfaces_2.charger.UnavailableReason,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    __metadata("design:type", Array)
], PortTelemetry.prototype, "unavailableReasons", void 0);
exports.PortTelemetry = PortTelemetry;
/**
 * Latest telemetry for a given charger.
 */
class ChargerTelemetry {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "OCPP identifier for the charger",
        example: "CHARGER_001",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], ChargerTelemetry.prototype, "ocppId", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Serial number of the charger",
        example: "CHARGER_001",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], ChargerTelemetry.prototype, "serialNumber", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Human-readable charger identifier",
        example: "Main St Charger #1",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], ChargerTelemetry.prototype, "friendlyId", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Maximum power limit enforced by charger hardware in kW",
        example: 150.0,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], ChargerTelemetry.prototype, "chargerPowerHardcap", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Maximum power advertised by the charger in kW",
        example: 150.0,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], ChargerTelemetry.prototype, "chargerAdvertisedMaxPower", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Telemetry data for each charging port",
        type: PortTelemetry,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => PortTelemetry),
    __metadata("design:type", Array)
], ChargerTelemetry.prototype, "ports", void 0);
exports.ChargerTelemetry = ChargerTelemetry;
/**
 * Latest telemetry for a given powernode.
 */
class PowernodeTelemetry {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Powernode identifier",
        example: 1,
        type: Number,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], PowernodeTelemetry.prototype, "id", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "State of charge percentage (0-100)",
        example: 85.5,
        type: Number,
        minimum: 0,
        maximum: 100,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], PowernodeTelemetry.prototype, "soc", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Current charge rate in kW",
        example: 50.0,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], PowernodeTelemetry.prototype, "chargeRateKw", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Current battery status",
        enum: ee_proto_interfaces_1.events_svc.BatteryStatus,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], PowernodeTelemetry.prototype, "batteryStatus", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Current powernode operational status",
        enum: ee_proto_interfaces_1.events_svc.PowernodeStatus,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], PowernodeTelemetry.prototype, "powernodeStatus", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Currently active power profile configuration",
        type: Object,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsObject)(),
    (0, class_validator_proxy_1.ValidateNested)(),
    (0, class_transformer_proxy_1.Type)(() => Object),
    __metadata("design:type", Object)
], PowernodeTelemetry.prototype, "activePowerProfile", void 0);
exports.PowernodeTelemetry = PowernodeTelemetry;
/**
 * Telemetry for a site.
 */
class SiteHardwareTelemetry {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Telemetry data from power nodes at the site",
        type: PowernodeTelemetry,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => PowernodeTelemetry),
    __metadata("design:type", Array)
], SiteHardwareTelemetry.prototype, "powernodes", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Telemetry data from chargers at the site",
        type: ChargerTelemetry,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => ChargerTelemetry),
    __metadata("design:type", Array)
], SiteHardwareTelemetry.prototype, "chargers", void 0);
exports.SiteHardwareTelemetry = SiteHardwareTelemetry;
/**
 * An estimate for demand charge across an arbitrary interval.
 */
class DemandEstimate {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Date for the demand estimate in MM/DD/YYYY format",
        example: "12/15/2023",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], DemandEstimate.prototype, "date", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Demand charge estimate with PowerNode in cents",
        example: 1250,
        type: Number,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], DemandEstimate.prototype, "demandChargeWithPowernode", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Demand charge estimate without PowerNode in cents",
        example: 2100,
        type: Number,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], DemandEstimate.prototype, "demandChargeWithoutPowernode", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Precision for demand charge values (decimal places)",
        example: 2,
        type: Number,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], DemandEstimate.prototype, "demandChargePrecision", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Peak power with PowerNode in kW",
        example: 125.5,
        type: Number,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], DemandEstimate.prototype, "peakPowerWithPowernodeKw", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Peak power without PowerNode in kW",
        example: 210.8,
        type: Number,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], DemandEstimate.prototype, "peakPowerWithoutPowernodeKw", void 0);
exports.DemandEstimate = DemandEstimate;
/**
 * A tax rule.
 */
class TaxRule {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "The applicable tax authority.",
        example: "State Sales Tax",
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], TaxRule.prototype, "description", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "The tax rate in decimal format.",
        example: 0.0875,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TaxRule.prototype, "rate", void 0);
exports.TaxRule = TaxRule;
class SiteTaxes {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Whether to use the suggested tax rate or manual override.",
        example: true,
    }),
    (0, class_validator_proxy_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], SiteTaxes.prototype, "useSuggestedTaxRate", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Suggested tax rules from Avalara.",
        type: TaxRule,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => TaxRule),
    __metadata("design:type", Array)
], SiteTaxes.prototype, "suggestedTaxes", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Manual tax override rules.",
        type: TaxRule,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => TaxRule),
    __metadata("design:type", Array)
], SiteTaxes.prototype, "taxOverride", void 0);
exports.SiteTaxes = SiteTaxes;
class SetTaxes {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Whether to use the suggested tax rate or manual override.",
        example: true,
    }),
    (0, class_validator_proxy_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], SetTaxes.prototype, "useSuggestedTaxRate", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Manual tax override rules.",
        type: TaxRule,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => TaxRule),
    __metadata("design:type", Array)
], SetTaxes.prototype, "taxOverride", void 0);
exports.SetTaxes = SetTaxes;
